<template>
   <el-dialog
        @close="handleClose"
        :visible.sync="visible"
        width="35%"
        class="imgDialog"
        :show-close="false">
        <i class="el-icon-circle-close closeIcon" @click="handleClose"></i>
        <img :src="imgSrc" style="width:100%"/>
    </el-dialog>
</template>

<script>
export default {
    props: ["imgDialogVisible", "imgSrc"],
    data(){
        return {
            visible: false
        }
    },
    watch: {
        "imgDialogVisible": function() {
            this.visible = this.imgDialogVisible;
        },
    },
    mounted() {},
    methods:{
        handleClose(){
            this.$emit('closeImgDialog', false)
        },
    }
};
</script>
<style lang="scss">
.imgDialog{
  .el-dialog__header{
    padding: 0!important;
    background: white!important;
  }
  .el-dialog__body{
    padding: 0!important;
  }
}
.closeIcon{
    position: absolute;
    right: -30px;
    top: -30px;
    cursor: pointer;
    font-size: 32px;
    color: white;
}
</style>